import type { MediaData } from './models/media';
import type { TransactingToolType } from './models/transacting-tool';

/**
 * Event list/card item exposed by the whitelabel data API (getEvents).
 * Not to be confused with the consumer transaction `EventData`
 * (@yoop/consumer-app/transaction/model), which models the purchase-flow
 * context for a single event.
 */
export interface EventListItem {
  id: string;
  legacyId: string;
  name: string;
  vanityName: string;
  isSoldOut: boolean;
  startDate: string;
  endDate: string;
  eventAccessibilityType: AccessibilityType;
  locationName: string;
  //true if the user already have a Yoop
  hasYoop: boolean;
  //true if the user requested a Yoop through MyPrice, Wishlist or MyPriceOffers
  didRequestYoop: boolean;
  //true if the user can purchase more Yoop
  canGetMoreYoop: boolean;
  //Status for MyPriceOffers
  exchangeStatus: ExchangeStatus;
  //Min price the user can purchase or request an Yoop for; absent when the event has no min price
  minPrice?: string;
  //Images for that event
  media: MediaData[];
  status: EventStatus;
  //Currency abbreviation (USD, CAD, EUR, ...)
  currency: string;
  activeMarketplace?: ActiveMarketplace;
  announcement?: string;
}

export interface ActiveMarketplace {
  type: TransactingToolType;
  numberOfListings: number;
}

export enum ExchangeStatus {
  Disabled = 'DISABLED',
  Offer = 'OFFER',
  Request = 'REQUEST',
}

// TODO [Packages - LP - WL Cleanups]: Combine with EventAccessibility and adjust server model usage
export enum AccessibilityType {
  LiveAttendance = 'LIVE_ATTENDANCE',
  Streaming = 'STREAMING',
}

export enum EventStatus {
  New = 'NEW',
  Requested = 'REQUESTED',
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Upcoming = 'UPCOMING',
  SoldOut = 'SOLD_OUT',
}
